// CmcUsageWidget/CmcUsageFetcher.js
// Singleton — does exactly 1 thing: raw I/O. No mapping, no business logic.
// TEMPORARY: mocked until CmcService.getUsageItems() (backend CmcAgent.GetUsages()) is wired.
import cmcService from '@/services/CmcService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'CmcUsageFetcher';

class CmcUsageFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches the raw usage items (CmcUsageItemDto shape) — mocked for now.
     * @returns {Promise<object[]>}
     */
    fetch = async () => {
        try {
            const response = await cmcService.getUsages();
            return response?.data?.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const cmcUsageFetcher = new CmcUsageFetcher();
export default cmcUsageFetcher;
